import {useEffect,useState } from 'react';
import PropTypes from 'prop-types';
import { Typography,TextField, Box, Dialog, makeStyles, withStyles, Button, Theme, createStyles, DialogContent, Grid } from '@material-ui/core';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import { Loading } from '../commonLoadings';
import Config from "../../../config/config";
import { loadStripe } from '@stripe/stripe-js/pure';
import { getBillingDetails,notificationFail, setLoading, getStripeCustomerDetail } from "../../../store/actions/admin/user";
import { useSelector, useDispatch } from 'react-redux';
import axios from 'axios'
import CloseIcon from '@material-ui/icons/Close';
import CustomSnackBar from '../../pages/creator/experienceManager/participantsDashboard/component/CustomSnackBar';
import {
    CardElement,
    Elements,
    useStripe,
    useElements,
} from '@stripe/react-stripe-js';
import {setIsUserVerication} from "../../../store/actions/auth/auth";
import CreditCardTwoToneIcon from '@material-ui/icons/CreditCardTwoTone';
const styles = (theme: Theme) =>
    createStyles({
        root: {
        },
        modalHeader: {
          paddingTop: theme.spacing(2),
          paddingBottom: theme.spacing(1),
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        },
        closeButton: {
          color: theme.palette.grey[500],
          fontFamily: 'roboto-bold',
        },
        closeBtnIcon: {
          color: '#212D4080',
          width: 24,
          height: 24,
          fontFamily: 'roboto-bold'
        },
        modaltitle: {
          fontFamily: 'roboto-bold',
          fontSize: 18,
          color: '#212D40',
          textAlign: 'left'
        }
    });
const auth_token = localStorage.getItem("auth_token")
const idToken = localStorage.getItem("idToken")
const useStyles = makeStyles(() => ({
    root: {},
    paper: {
        borderRadius: '10px !important'
    },
    btn: {
        fontFamily: 'roboto-regular',
        textTransform:"initial"
    },
    cancelBtn: {
        margin: '0 15px',
        height: 37,
        borderRadius: 6,
        textTransform: 'none',
        fontSize: 14,
        color: '#697683',
    },
    contentText: {
        marginTop: '12px',
        fontFamily: 'roboto-regular',
    },
    cardholderName: {
        top: '497px',
        left: '347px',
        width: '70px',
        height: '16px',
        textAlign: 'left',
        letterSpacing: '-0.21px',
        color: '#8F99A3',
        opacity: 1,
        fontFamily: 'roboto-regular',
    },
    label: {
        "&$focusedLabel": {
            fontSize: 12,
            fontFamily: 'roboto-bold',
            color: "#606B76"
        },
        "&$erroredLabel": {
            color: "#707070"
        }
    },
    focusedLabel: {},
    erroredLabel: {},
    underline: {
        fontSize: 14,
        fontFamily: 'roboto-regular',
        color: '#697683',
        "&$error:after": {
            borderBottomColor: "#017AEF"
        },
        "&:after": {
            borderBottom: `3px solid #017AEF`
        }
    },
    error: {},
    cardDetails: {
        background: '#F0F0F0',
        padding: '35px',
        minHeight: '190px',
        height: '100%'
    },
    billingDetails: {
        padding:35
    },
    subdesc: {
        fontSize: '12px',
        fontWeight: 'bold',
        color: '#606b76',
        display: 'block',
        marginBottom: '10px',
    },
    desc: {
        fontSize: '20px',
        fontFamily: 'Spartan-bold',
        margin:0
    },
    price: {
        fontSize: '48px',
        fontFamily: 'Spartan-bold',
        margin: 10,
    },
    pricewrapper: {
        textAlign: 'center'
    },
    textLight: {
        fontSize: '16px',
        fontFamily: 'roboto-regular',
        color: '#606B76',
        letterSpacing: '0.4px'
    },
    textLightSmall: {
        fontSize: '16px',
        fontFamily: 'roboto-regular',
        color: '#606B76',
        letterSpacing: '0.4px'
    },
    priceDateWrapper: {
        marginTop: 50,
        textAlign: 'center'
    },
    descDate: {
        fontSize: '24px',
        fontFamily: 'Spartan-bold',
    },
    cardName: {
        marginTop: 50,
    },
    linkText: {
        color: '#017aef',
        cursor: 'pointer',
        fontSize: '12px',
        fontFamily: 'roboto-regular',
    },
    description: {
        fontSize: '14px',
    },
    addLicenseModal:{
        "& .totalAmt":{
          marginBottom: "9px",
          "& strong":{
            display: "block",
            color: "#606B76",
            fontSize: "12px",
            marginBottom: "17px",
          },
          "& p":{
            color: "#212D40",
            fontSize: "48px",
            fontFamily: "Spartan-bold",
            margin: 0,
          }
        },
        "& .perMonthUser":{
          "& strong":{
            display: "block",
            color: "#606B76",
            fontSize: "16px",
            fontWeight: 400,
            marginBottom: "5px",
          },
          "& p":{
            color: "#606B76",
            fontSize: "10px",
            textTransform: "uppercase",
            margin: 0,
          }
        },
        "& .subDate":{
          "& strong":{
            display: "block",
            color: "#606B76",
            fontSize: "12px",
            marginBottom: "12px",
          },
          "& p":{
            color: "#212D40",
            fontSize: "24px",
            fontFamily: "Spartan-bold",
            margin: 0,
          }
        }
    }
}));

const DialogTitle = withStyles(styles)((props: any) => {
    const { children, classes, onClose, ...other } = props;
    return (
        <MuiDialogTitle disableTypography className={classes.modalHeader} {...other}>
          <Typography variant="h5" className={classes.modaltitle}>{children}</Typography>
          {onClose ? (
            <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
              <CloseIcon classes={{ root: classes.closeBtnIcon }} />
            </IconButton>
          ) : null}
        </MuiDialogTitle>
    );
});

AddCardDetailModal.propTypes = {
    onClose: PropTypes.func,
    open: PropTypes.bool.isRequired,
    departmentData: PropTypes.object,
    selectedPlan: PropTypes.any,
    openCloseSuccessModal: PropTypes.func,
    stripe_mode: PropTypes.any,
};

const CheckoutForm = (props: any) => {
    const { closeModal, departmentData} = props;
    
    
    const { loading } = useSelector((state: any) => state.adminUser);
    const [cardholderName, setcardholderName] = useState('');
    const dispatch = useDispatch();
    const classes = useStyles();
    const stripe: any = useStripe();
    
    const elements: any = useElements();
    const loginUserData = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data") || '{}') : "";
    const apolloClient = useSelector((state: any) => state.apolloClient);
    const [snackAlertType, handleSnackAlertType] = useState('');
    const [snackAlertMsg, handleSnackMsg] = useState('');
    const [isShownSnackAlert, setShownSnackAlert] = useState(false);
    const [showCustomerDetails, setshowCustomerDetails] = useState < any > ('');
    const {stripeCustomerDetail } = useSelector((state: any) => state.adminUser);
    useEffect(() => {
        if (stripeCustomerDetail) {
            setshowCustomerDetails(stripeCustomerDetail)
        }
    }, [stripeCustomerDetail])

    function showSnackAlert(msg: string, type: string) {
        handleSnackMsg(msg);
        handleSnackAlertType(type);
        setShownSnackAlert(true);
    }

    function hideSnackAlert() {
        setShownSnackAlert(false);
    }


    const onChange = (event: any) => {
        if (event.target.name === "cardholderName") {
            setcardholderName(event.target.value);
        }
    };

    const closeDialog = () => {
        closeModal()
        dispatch(setLoading(false))
    };

    
    const closeCardDetailSection = () => {
        setcardholderName('')
    };

    //update creadit card detail and set new payment method as default in stripe
    const updateCreditCard = async () => {
        if (!loginUserData.customer_name) {
            dispatch(notificationFail({}, "Unable to get customer name of this user"));
            return
        }
        const obj = {
            customer_name: loginUserData.customer_name,
            display_name: loginUserData.customer_display_name,
            customer_id: loginUserData.customer_id,
        }
        departmentData.customers = obj
        dispatch(setLoading(true))

        if (!cardholderName) {
            dispatch(notificationFail({}, "Please enter cardholder name."))
            dispatch(setLoading(false))
            return
        }
        await stripe.createPaymentMethod({
                type: 'card',
                card: elements.getElement(CardElement),
                billing_details: {
                    name: cardholderName,
                },
            })
            .then(async function(result: any) {
                if (result.error) {
                    dispatch(notificationFail({}, result.error.message))
                    dispatch(setLoading(false))
                    return
                }
                // Handle result.error or result.paymentMethod
                const updateCardReq = {
                    customer_id: departmentData.stripe_customer_id,
                    cardData: result.paymentMethod,
                    department_data: departmentData,
                }
                await axios.post(Config.API_URL, {
                    query: `mutation updateCreditCard($cardData: JSON!) {
                  updateCreditCard(cardData: $cardData) {
                    data status message data
                  }
                }`,
                    variables: {
                        cardData: updateCardReq,
                    }
                }, {
                    headers: {
                        accesstoken: auth_token ? auth_token : "",
                        schemaname: "public",
                        idToken: idToken ? idToken : ""
                    }
                }).then(async (ccResult: any) => {
                    if (ccResult.data.data.updateCreditCard.status === "true") {
                        showSnackAlert(ccResult.data.data.updateCreditCard.message, 'success');
                        if (departmentData.stripe_customer_id) {
                            const req = { stripe_customer_id: departmentData.stripe_customer_id };
                            dispatch(getStripeCustomerDetail(apolloClient.client, req));
                            const request = { username: loginUserData.username };
                            dispatch(getBillingDetails(apolloClient.client, request));  
                        }
                        setTimeout(function(){
                          closeDialog()
                        },2000)
                        closeCardDetailSection()
                    } else {
                        dispatch(notificationFail({}, ccResult.data.data.updateCreditCard.message))
                    }
                    dispatch(setLoading(false))
                }).catch((error: any) => {
                    if(error.response.status === 400 || error.response.status === 401){
                      dispatch(setIsUserVerication(true))
                    }
                    dispatch(notificationFail({}, error.message))
                    dispatch(setLoading(false))
                });

            }).catch((error: any) => {
                dispatch(notificationFail({}, error.message))
                dispatch(setLoading(false))
            });
    };

    return (
        <form>
      <CustomSnackBar type={snackAlertType} message={snackAlertMsg} open={isShownSnackAlert} onClose={hideSnackAlert} />
      <DialogContent className="customCardDesign">
        <Grid container style={{border:"1px solid #e4e4e4",borderRadius:"5px",boxShadow: '0 0px 2px 0 rgba(0, 0, 0, 0.2), 0 0px 0px 0 rgba(0, 0, 0, 0.19)'}}>
          <Grid item md={12}>
            <Box className={classes.cardDetails}>
              <Grid container>
                {
                  <>
                    <Grid item md={12}>
                      <TextField
                        value={cardholderName}
                        InputLabelProps={{
                          classes: {
                            root: classes.label,
                            focused: classes.focusedLabel,
                            error: classes.erroredLabel
                          },
                        }}
                        InputProps={{
                          classes: {
                            root: classes.underline,
                            error: classes.error
                          }
                        }}
                        fullWidth
                        size="small"
                        id="cardholderName"
                        label="Cardholder Name"
                        name="cardholderName"
                        onChange={onChange}
                      />
                    </Grid>
                    <Grid item md={12} style={{marginTop:'30px'}}>
                      <CardElement />
                    </Grid>
                  </>
                }

              {showCustomerDetails && stripeCustomerDetail.paymentMethods && stripeCustomerDetail.paymentMethods.length > 0 &&
                  <>
                  <Grid item md={12} style={{marginTop:"52px"}} container>
                    <Grid item md={6}>
                    <span className={classes.subdesc}>Cardholder Name</span>
                    <span className={classes.cardholderName}>{stripeCustomerDetail.paymentMethods[0].billing_details.name}</span>
                    </Grid>
                  </Grid>
                  <Grid item md={12} style={{marginTop:'30px'}}>
                  <div className="cardBox">
                    <Grid item md={6}>
                      <CreditCardTwoToneIcon  style={{fontSize:20,color:'#c1bcbc'}}/>
                      <span style={{fontWeight:'bold',color:"#606B76"}}>Saved Card</span>
                    </Grid>
                    <Grid item md={6}>
                      <span style={{fontWeight:'bold',color:"#606B76",float:"right"}}>**** **** **** {stripeCustomerDetail.paymentMethods[0].card.last4}</span>
                    </Grid>
                     
                  </div>
                  </Grid>
                  </>
                }
              </Grid>
            </Box>
          </Grid>
        </Grid>
      </DialogContent>
      <Box mt={3} mb={3} mr={4} display='flex' justifyContent='flex-end'>
        {departmentData &&
          <>
            <Button variant="contained" className={classes.cancelBtn} onClick={closeDialog}>
              Cancel
            </Button>
              <Button variant="contained" disabled={!stripe} color='primary' className={classes.btn} onClick={updateCreditCard}>
                {loading? <Loading style={{ width: 60, height: 30, marginTop: -20 }} />: 'Save'}
              </Button>
          </>
        }
      </Box>
    </form>
    );
};

function AddCardDetailModal({ open, onClose, departmentData, selectedPlan, openCloseSuccessModal,stripe_mode }: any) {
    const classes = useStyles();
    const dispatch = useDispatch();
    let stripePromise:any;
    if(stripe_mode === "TEST"){
        stripePromise = loadStripe(Config.stripePublishableKeyTest);
    }
    if(stripe_mode === "LIVE"){
        stripePromise = loadStripe(Config.stripePublishableKeyLive);
    }
    // close modal
    const closeModal = () => {
        onClose()
        dispatch(setLoading(false))
    };

    const children = <CheckoutForm closeModal={closeModal}  openCloseSuccessModal={openCloseSuccessModal} departmentData={departmentData} selectedPlan={selectedPlan}/>

    return (
        <Dialog
      disableEscapeKeyDown
      fullWidth={true}
      maxWidth={'sm'}
      scroll='paper'
      open={open}
      classes={{
        root: classes.root,
        paper: classes.paper
      }}
    >
      <DialogTitle onClose={closeModal}>Add Card Detail</DialogTitle>
      <Elements {...{children, stripe: stripePromise}} />
     </Dialog>
    );
}

export default AddCardDetailModal;